'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'holly-berry';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f7aa';
var svgPathData = 'M256 16a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm64 48A64 64 0 1 1 192 64a64 64 0 1 1 128 0zM15.3 348.7L80 327.1l1.1-61.8 .3-16.1 16 2.4 62.6 9.3 62.2-28.6L240 224l-3.6 19.3L224 310.6l24.5 58.5 6.2 14.8-15.3 4.9L176 408.9l-2.2 63.4-.6 16.2-15.9-3.3L97.8 472.9 34 503.4 16 512l3.9-19.6 13.9-69.3L7.1 368.3 0 353.8l15.3-5.1zM96 327.4l-.2 11.3-10.7 3.6L22.4 363.2l25.8 52.9 2.4 4.9-1.1 5.3L38 483.8l52.9-25.3 4.9-2.3 5.3 1.1L158 469l2.1-60.7 .4-11.3 10.8-3.4 62-19.7-23.9-57.2-1.8-4.4 .9-4.7 10.4-56.3-52 23.9-4.3 2-4.7-.7-60.6-9L96 327.4zm400.7 21.3l15.3 5.1-7.1 14.5-26.7 54.8 13.9 69.3L496 512l-18-8.6-63.7-30.5-59.6 12.4-15.9 3.3-.6-16.2L336 408.9l-63.4-20.1-15.3-4.9 6.2-14.8L288 310.6l-12.4-67.4L272 224l17.8 8.2L352 260.8l62.6-9.3 16-2.4 .3 16.1 1.1 61.8 64.7 21.6zM416 327.4l-1.1-59.8-60.6 9-4.7 .7-4.3-2-52-23.9 10.4 56.3 .9 4.7-1.8 4.4L278.8 374l62 19.7 10.8 3.4 .4 11.3L354 469 411 457.2l5.3-1.1 4.9 2.3L474 483.8l-11.5-57.5-1.1-5.3 2.4-4.9 25.8-52.9-62.7-20.9-10.7-3.6-.2-11.3zM112 144c0-33.2 25.2-60.4 57.5-63.7c1 5.4 2.5 10.7 4.5 15.7c-25.6 1-46 22.1-46 48c0 26.5 21.5 48 48 48c25.8 0 46.9-20.4 48-46c5 2 10.3 3.5 15.7 4.5C236.4 182.8 209.2 208 176 208c-35.3 0-64-28.7-64-64zm224 64c-33.2 0-60.4-25.2-63.7-57.5c5.4-1 10.7-2.5 15.7-4.5c1 25.6 22.1 46 48 46c26.5 0 48-21.5 48-48c0-25.8-20.4-46.9-46-48c2-5 3.5-10.3 4.5-15.7C374.8 83.6 400 110.8 400 144c0 35.3-28.7 64-64 64z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHollyBerry = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;